import React from "react";
import { useSnapshot } from "valtio";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Autoplay } from "swiper";

import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { store } from "../../store";

import "swiper/swiper-bundle.min.css";
import { ImageDisplay } from "../../../../Common/ImageDisplay";

SwiperCore.use([EffectCoverflow, Autoplay]);

export function Section2Preview({ deviceType, section }: any): JSX.Element {
    let localData: any = templateActions.getNestedObject([
        "template",
        "SiteWeb",
        "LaindingPage",
        section,
        "Images",
        deviceType,
    ]);
    let template =
        localData !== null ? JSON.parse(JSON.stringify(localData)) : [];
    const { selectedLanguage } = useSnapshot(store);
    const title =
        templateActions.getNestedObject([
            "template",
            "SiteWeb",
            "LaindingPage",
            section,
            "Title",
            selectedLanguage,
        ]) || "";

    return (
        <div
            style={{
                height: "80vh",
                overflow: "hidden",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <React.Fragment>
                <div
                    style={{
                        textAlign: "center",
                        padding: "1rem",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "2rem",
                            fontWeight: "bold",
                            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                            margin: 0,
                        }}
                    >
                        {title}
                    </h1>
                </div>
                {template.length > 0 && (
                    <div style={{ perspective: "1200px" }}>
                        {template.length === 1 ? (
                            <div
                                style={{
                                    width: "60%",
                                    height: "600px",
                                    margin: "auto",
                                    marginTop: "5%",
                                }}
                            >
                                <ImageDisplay item={template[0].Pub} />
                            </div>
                        ) : template.length === 2 ? (
                            <div
                                style={{
                                    width: "100%",
                                    height: "600px",
                                    marginTop: "5%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "5% 5%",
                                }}
                            >
                                <ImageDisplay
                                    item={template[0].Pub}
                                    width={"47%"}
                                />
                                <ImageDisplay
                                    item={template[1].Pub}
                                    width={"47%"}
                                />
                            </div>
                        ) : (
                            <Swiper
                                effect="coverflow"
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={template.length > 3 ? 3 : 2}
                                loop={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}
                                coverflowEffect={{
                                    rotate: 0,
                                    stretch: 0,
                                    depth: 300,
                                    modifier: 1,
                                    slideShadows: false,
                                }}
                                style={{
                                    width: "100%",
                                    padding: "40px 0",
                                }}
                            >
                                {template.map((item: any, index: number) => (
                                    <SwiperSlide
                                        key={index}
                                        style={{
                                            width: "240px",
                                            height: "600px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <ImageDisplay item={item.Pub} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}
                    </div>
                )}
            </React.Fragment>
        </div>
    );
}
